import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import { isLockedAvatar, requestAvatarChange, showLockedAlert } from './utils/avatarLock';

/**
 * Replace the upload/remove buttons in AvatarEditor with a "locked" notice
 * for verified users, and intercept every imperative upload/remove path so
 * the avatar is truly immutable on the client.
 *
 * The backend EnforceAvatarLock listener is the actual security boundary;
 * these overrides exist purely for UX.
 */
export default function addAvatarLock() {
  extend('flarum/forum/components/AvatarEditor', 'controlItems', function (items) {
    if (!isLockedAvatar(this)) return;
    if (items.has('upload')) items.remove('upload');
    if (items.has('remove')) items.remove('remove');
    const user = this.attrs.user;
    items.add('verified-locked', m("div", {
      className: "AvatarEditor-lockedNotice"
    }, m("i", {
      className: "icon fas fa-lock"
    }), m("span", {
      className: "AvatarEditor-lockedNotice-title"
    }, app.translator.trans('ramon-verified.forum.avatar.locked_label')), m("span", {
      className: "AvatarEditor-lockedNotice-text"
    }, app.translator.trans('ramon-verified.forum.avatar.locked_help')), m(Button, {
      className: "Button Button--primary AvatarEditor-lockedNotice-button",
      icon: "fas fa-pen",
      onclick: e => {
        if (e) {
          e.stopPropagation();
        }
        requestAvatarChange(user);
      }
    }, app.translator.trans('ramon-verified.forum.avatar.request_change_button'))), 100);
  });
  override('flarum/forum/components/AvatarEditor', 'quickUpload', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const e = args[0];
    if (isLockedAvatar(this)) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      showLockedAlert();
      return;
    }
    return original(e);
  });
  override('flarum/forum/components/AvatarEditor', 'openPicker', function (original) {
    if (isLockedAvatar(this)) {
      showLockedAlert();
      return;
    }
    return original();
  });
  override('flarum/forum/components/AvatarEditor', 'remove', function (original) {
    if (isLockedAvatar(this)) {
      showLockedAlert();
      return;
    }
    return original();
  });
  override('flarum/forum/components/AvatarEditor', 'dropUpload', function (original) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    const e = args[0];
    if (isLockedAvatar(this)) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      showLockedAlert();
      return;
    }
    return original(e);
  });
}